import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Button from '@/components/common/Button/Button';
import MotionDiv from '@/components/common/Motion/MotionDiv';
import NewExpense from '@assets/visuals/new-expense.webp'

interface Props {
  className?: string;
}

const ExpensesWidget = ({ className = '' }: Props) => {
  const { t } = useTranslation();

  return (
    <MotionDiv delay={0.2} className='tour-recommendation-widget'>
      <Link to={'/expenses/memo'} className={`relative flex flex-col bg-zinc-100 rounded-2xl p-4 flex items-start overflow-hidden ${className}`}>
        <img
          src={NewExpense}
          className={`h-[12rem] absolute top-0 right-0 transition-transform duration-300 ease-out`}
        />
        <p className="font-semibold text-[1.125rem] text-[#000] w-[8.875rem] mb-6">
          {t('expenses.addMoreExpenses')}
        </p>
        <Button variant='secondary'
          className='py-[0.25rem] px-[0.87rem]'
        >
          <span>{t('expenses.whatCanIAdd')}</span>
        </Button>
      </Link>
    </MotionDiv>
  );
};

export default ExpensesWidget;